<template>
  <item-wrapper
    v-if="date !== null"
    class="date-prop"
    :tooltip="prop.label"
    :show-tooltip="showTooltip"
    :style="{ fontSize }"
  >
    <m-icon
      v-if="showIcon"
      class="_icon"
      type="calendar"
    />
    <div class="_date">
      {{ formattedDate }}
    </div>
  </item-wrapper>
</template>

<script>
import ItemWrapper from '@/components/list/ItemWrapper.vue';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import { dateFormatter } from 'shared/lib/date';
import { fontSizes } from 'shared/font-sizes';
import { getValueFromEntity } from '@/lib/props';

export default {
  name: 'DateProp',
  props: {
    prop: {
      type: Object,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
    propertyValuesKey: {
      type: String,
      default: 'properties',
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: String,
      default: fontSizes[4],
    },
  },
  setup() {
    const { userLang } = useLoggedInUser();
    return { userLang };
  },
  components: { ItemWrapper },
  computed: {
    date() {
      return getValueFromEntity(this.prop, this.entity, this.propertyValuesKey);
    },
    formattedDate() {
      const formatter = dateFormatter(
        this.prop.property.dateFormat,
        this.prop.property.timeFormat,
        this.userLang,
        this.$t,
      );
      return formatter(this.date);
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .date-prop {
    display: flex;
    align-items: center;
    white-space: nowrap;

    ._icon {
      margin-right: .4rem;
    }
  }
</style>
